const Button = {
    "options": {
        "data": {
            "text": {
                "type": "Text"
            },
            "images": [
                {
                    "to": "",
                    "src": ""
                }
            ]
        },
        "customization": {},
        "widgets": {
            "Menu_titleSettings": {
                "order": 1,
                "type": "Menu",
                "renderOptions": {
                    "controlKey": "titleSettings"
                },
                "options": {
                    "textSize": {
                        "type": "RangePx",
                        "data": {
                            "max": 30,
                            "min": 0,
                            "step": 1
                        },
                        "order": 1
                    },
                    "textAlignment": {
                        "type": "LeftCenterRight",
                        "order": 2
                    },
                    "textColor": {
                        "type": "HexColor",
                        "order": 3
                    },
                    "borderColor": {
                        "type": "HexColor",
                        "order": 4
                    },
                    "innerBackgroundColor": {
                        "type": "HexColor",
                        "order": 5
                    },
                    "buttonAlignment": {
                        "type": "LeftCenterRight",
                        "order": 6
                    },
                    "textWeight": {
                        "type": "SelectBox",
                        "data": {
                            "selectOptions": [
                                "100",
                                "200",
                                "300",
                                "400",
                                "500",
                                "600",
                                "700",
                                "800",
                                "900"
                            ]
                        },
                        "order": 6
                    }
                }
            },
            "Menu_GeneralSettings": {
                "order": 1,
                "type": "Menu",
                "renderOptions": {
                    "controlKey": "generalSettings"
                },
                "options": {
                    "widget.Tabs_1": {
                        "type": "Tabs",
                        "order": 8,
                        "options": {
                            "containerPadding": {
                                "data": {
                                    "max": 30,
                                    "min": 0,
                                    "step": 1,
                                    "svgType": "edge"
                                },
                                "type": "FourPx"
                            },
                            "padding": {
                                "data": {
                                    "max": 20,
                                    "min": 0,
                                    "step": 2,
                                    "svgType": "edge"
                                },
                                "type": "FourPx"
                            },
                            "borderRadius": {
                                "data": {
                                    "max": 30,
                                    "min": 0,
                                    "step": 1,
                                    "svgType": "border"
                                },
                                "type": "FourPx"
                            }
                        }
                    },
                    "widget.ToggleRadioTabs_1": {
                        "type": "ToggleRadioTabs",
                        "order": 9,
                        "renderOptions": {
                            "direction": "row",
                            "controlKey": "backgroundType"
                        },
                        "options": {
                            "backgroundImage": {
                                "type": "ImageUploader"
                            },
                            "backgroundColor": {
                                "type": "HexColor"
                            }
                        }
                    },
                    "backgroundSize": {
                        "type": "Radio",
                        "order": 10,
                        "data": {
                            "direction": "row",
                            "radioOptions": [
                                "cover",
                                "contain",
                                "stretch"
                            ]
                        }
                    },
                    "boxShadow": {
                        "type": "ChildComponentRenderer",
                        "order": 11,
                        "data": {
                            "componentNames": [
                                "shadow1",
                                "shadow2",
                                "shadow3"
                            ]
                        }
                    }
                }
            },
            "Menu_ButtonInternalLinking": {
                "order": 1,
                "type": "Menu",
                "renderOptions": {
                    "controlKey": "internalLinking"
                },
                "options": {
                    "linking": {
                        "type": "Linking",
                        "order": 12
                    }
                }
            },
            "Menu_ButtonIconSettings": {
                "order": 1,
                "type": "Menu",
                "renderOptions": {
                    "controlKey": "ButtonIconSettings"
                },
                "options": {
                    "widget.ToggleTabs_1": {
                        "type": "ToggleTabs",
                        "order": 5,
                        "renderOptions": {
                            "controlKey": "isIcon"
                        },
                        "options": {
                            "icon": {
                                "type": "IconSelector",
                                "data": {
                                    "defaultIcon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png"
                                },
                                "order": 1
                            },
                            "iconBackgroundColor": {
                                "type": "HexColor",
                                "order": 6
                            },
                            "iconColor": {
                                "type": "HexColor",
                                "order": 7
                            },
                            "iconWidth": {
                                "data": {
                                    "max": 40,
                                    "min": 0,
                                    "step": 1
                                },
                                "type": "RangePx"
                            },
                            "iconBorderRadius": {
                                "data": {
                                    "max": 40,
                                    "min": 0,
                                    "step": 1,
                                    "svgType": "border"
                                },
                                "type": "FourPx"
                            }
                        }
                    }
                }
            }
        }
    },
    "variants": [
        {
            "id": "Button_1",
            "name": "Button_1",
            "type": "Button",
            "data": {
                "text": ""
            },
            "customization": {
                "icon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png",
                "isIcon": false,
                "padding": "8px 8px 8px 8px",
                "textSize": "12px",
                "iconColor": "#FFFFFF",
                "iconWidth": "20px",
                "textColor": "#FFFFFF",
                "textWeight": "100",
                "borderColor": "#ffffff",
                "borderRadius": "0px 0px 0px 0px",
                "textAlignment": "center",
                "backgroundType": "-",
                "backgroundColor": "#FFFFFF",
                "backgroundImage": "",
                "buttonAlignment": "center",
                "containerPadding": "12px 12px 12px 12px",
                "iconBorderRadius": "0px 0px 0px 0px",
                "iconBackgroundColor": "#C1A7FF",
                "innerBackgroundColor": "#212121",
                "linking": {
                    "pointTo": {
                        "pointTo": "BeforeSearch",
                        "pointToType": "defaultPage"
                    },
                    "internalLinking": true
                }
            },
            "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Button_1.png",
            "minMobileAppVersion": 1,
            "isComingSoon": false
        },
        {
            "id": "Button_2",
            "name": "Button_2",
            "type": "Button",
            "data": {
                "text": ""
            },
            "customization": {
                "icon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png",
                "isIcon": false,
                "padding": "8px 8px 8px 8px",
                "textSize": "12px",
                "iconColor": "#C1A7FF",
                "iconWidth": "20px",
                "textColor": "#212121",
                "textWeight": "100",
                "borderColor": "#212121",
                "borderRadius": "0px 0px 0px 0px",
                "textAlignment": "center",
                "backgroundType": "-",
                "backgroundColor": "#FFFFFF",
                "backgroundImage": "",
                "buttonAlignment": "center",
                "containerPadding": "8px 8px 8px 8px",
                "iconBorderRadius": "0px 0px 0px 0px",
                "iconBackgroundColor": "#FAF8FF",
                "innerBackgroundColor": "#ffffff",
                "linking": {
                    "pointTo": {
                        "pointTo": "BeforeSearch",
                        "pointToType": "defaultPage"
                    },
                    "internalLinking": true
                }
            },
            "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Button+2.png",
            "minMobileAppVersion": 1,
            "isComingSoon": false
        },
        {
            "id": "Button_3",
            "name": "Button_3",
            "type": "Button",
            "data": {
                "text": ""
            },
            "customization": {
                "icon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005009910.png",
                "isIcon": true,
                "padding": "8px 8px 8px 8px",
                "textSize": "12px",
                "iconColor": "#FFFFFF",
                "iconWidth": "20px",
                "textColor": "#FFFFFF",
                "textWeight": "100",
                "borderColor": "#C1A7FF",
                "borderRadius": "0px 0px 0px 0px",
                "textAlignment": "left",
                "backgroundType": "-",
                "backgroundColor": "#C1A7FF",
                "backgroundImage": "",
                "buttonAlignment": "center",
                "containerPadding": "8px 8px 8px 8px",
                "iconBorderRadius": "0px 0px 0px 0px",
                "iconBackgroundColor": "#212121",
                "innerBackgroundColor": "#212121",
                "linking": {
                    "pointTo": {
                        "pointTo": "BeforeSearch",
                        "pointToType": "defaultPage"
                    },
                    "internalLinking": true
                }
            },
            "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Button+3.png",
            "minMobileAppVersion": 1,
            "isComingSoon": false
        },
        {
            "id": "Button_4",
            "name": "Button_4",
            "type": "Button",
            "data": {
                "text": ""
            },
            "customization": {
                "icon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005009910.png",
                "isIcon": true,
                "padding": "8px 8px 8px 8px",
                "textSize": "12px",
                "iconColor": "#000000",
                "iconWidth": "20px",
                "textColor": "#000000",
                "textWeight": "100",
                "borderColor": "#000000",
                "borderRadius": "0px 0px 0px 0px",
                "textAlignment": "left",
                "backgroundType": "-",
                "backgroundColor": "#FFFFFF",
                "backgroundImage": "",
                "buttonAlignment": "center",
                "containerPadding": "8px 8px 8px 8px",
                "iconBorderRadius": "0px 0px 0px 0px",
                "iconBackgroundColor": "#ffffff",
                "innerBackgroundColor": "#ffffff",
                "linking": {
                    "pointTo": {
                        "pointTo": "BeforeSearch",
                        "pointToType": "defaultPage"
                    },
                    "internalLinking": true
                }
            },
            "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Button+4.png",
            "minMobileAppVersion": 1,
            "isComingSoon": false
        },
        {
            "id": "Button_5",
            "name": "Button_5",
            "type": "Button",
            "data": {
                "text": ""
            },
            "customization": {
                "icon": "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/icons/1706005417301.png",
                "isIcon": false,
                "padding": "8px 8px 8px 8px",
                "textSize": "12px",
                "iconColor": "#C1A7FF",
                "iconWidth": "20px",
                "textColor": "#000000",
                "textWeight": "100",
                "borderColor": "#000000",
                "borderRadius": "0px 0px 0px 0px",
                "textAlignment": "center",
                "backgroundType": "-",
                "backgroundColor": "#FFFFFF",
                "backgroundImage": "",
                "buttonAlignment": "center",
                "containerPadding": "8px 8px 8px 8px",
                "iconBorderRadius": "0px 0px 0px 0px",
                "iconBackgroundColor": "#FAF8FF",
                "innerBackgroundColor": "#ffffff",
                "linking": {
                    "pointTo": {
                        "pointTo": "BeforeSearch",
                        "pointToType": "defaultPage"
                    },
                    "internalLinking": true
                }
            },
            "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Button+5.png",
            "minMobileAppVersion": 1,
            "isComingSoon": false
        },
        {
            "id": "Button_6",
            "name": "Button_6",
            "type": "Button",
            "data": {
                "text": ""
            },
            "customization": {
                "icon": "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/icons/1706005417301.png",
                "isIcon": false,
                "padding": "8px 8px 8px 8px",
                "textSize": "12px",
                "iconColor": "#FFFFFF",
                "iconWidth": "20px",
                "textColor": "#ffffff",
                "textWeight": "100",
                "borderColor": "#000000",
                "borderRadius": "0px 0px 0px 0px",
                "textAlignment": "center",
                "backgroundType": "-",
                "backgroundColor": "#FFFFFF",
                "backgroundImage": "",
                "buttonAlignment": "center",
                "containerPadding": "8px 8px 8px 8px",
                "iconBorderRadius": "0px 0px 0px 0px",
                "iconBackgroundColor": "#C1A7FF",
                "innerBackgroundColor": "#212121",
                "linking": {
                    "pointTo": {
                        "pointTo": "BeforeSearch",
                        "pointToType": "defaultPage"
                    },
                    "internalLinking": true
                }
            },
            "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Button+6.png",
            "minMobileAppVersion": 1,
            "isComingSoon": false
        },
        {
            "id": "Button_7",
            "name": "Button_7",
            "type": "Button",
            "data": {
                "text": ""
            },
            "customization": {
                "textSize": "12px",
                "textColor": "#FFFFFF",
                "borderColor": "#C1A7FF",
                "innerBackgroundColor": "#C1A7FF",
                "containerPadding": "8px 8px 8px 8px",
                "padding": "8px 8px 8px 8px",
                "borderRadius": "0px 0px 0px 0px",
                "backgroundColor": "#C1A7FF",
                "backgroundImage": "",
                "backgroundType": "-",
                "isIcon": false,
                "icon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png",
                "iconBackgroundColor": "#C1A7FF",
                "iconColor": "#FFFFFF",
                "iconWidth": "20px",
                "iconBorderRadius": "0px 0px 0px 0px",
                "textAlignment": "left",
                "buttonAlignment": "center",
                "textWeight": "100",
                "linking": {
                    "pointTo": {
                        "pointTo": "BeforeSearch",
                        "pointToType": "defaultPage"
                    },
                    "internalLinking": true
                }
            },
            "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Button+7.png",
            "minMobileAppVersion": 1,
            "isComingSoon": false
        },
        {
            "id": "Button_8",
            "name": "Button_8",
            "type": "Button",
            "data": {
                "text": ""
            },
            "customization": {
                "textSize": "12px",
                "textColor": "#C1A7FF",
                "borderColor": "#C1A7FF",
                "innerBackgroundColor": "#FAF8FF",
                "containerPadding": "8px 8px 8px 8px",
                "padding": "8px 8px 8px 8px",
                "borderRadius": "0px 0px 0px 0px",
                "backgroundColor": "#FFFFFF",
                "backgroundImage": "",
                "backgroundType": "-",
                "isIcon": false,
                "icon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png",
                "iconBackgroundColor": "#FAF8FF",
                "iconColor": "#C1A7FF",
                "iconWidth": "20px",
                "iconBorderRadius": "0px 0px 0px 0px",
                "textAlignment": "left",
                "buttonAlignment": "center",
                "textWeight": "100",
                "linking": {
                    "pointTo": {
                        "pointTo": "BeforeSearch",
                        "pointToType": "defaultPage"
                    },
                    "internalLinking": true
                }
            },
            "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Button+8.png",
            "minMobileAppVersion": 1,
            "isComingSoon": false
        }
    ]
}
 export default Button